import React, { useState, useEffect, useCallback } from "react";

const API_BASE_URL = "http://buy002.com/api";

const formatNumber = (num, digits = 4) => {
  if (num === null || num === undefined) return "-";

  if (Math.abs(num) < 0.0001 && num !== 0) {
    return parseFloat(num.toFixed(8));
  }
  return parseFloat(num).toFixed(digits);
};

function App() {

  const isMobile = window.innerWidth < 1600;

  const [dataCoins, setDataCoins] = useState([]);
  const [dataCoinsSecondary, setDataCoinsSecondary] = useState([]);
  const [marketData, setMarketData] = useState(null);
  const [botStatus, setBotStatus] = useState({});
  const [tradingPairs, setTradingPairs] = useState([]);
  const [bestTrade, setBestTrade] = useState(null);
  const [loading, setLoading] = useState(true);
  const [profitCount, setProfitCount] = useState(null);
  const [logs, setLogs] = useState([]);

  // 1. دریافت داده‌های اولیه کوین‌ها و وضعیت بات
  const fetchInitialData = useCallback(async () => {
    try {
      const coinsRes = await fetch(`${API_BASE_URL}/bot/coins`);
      const coinsData = await coinsRes.json();
      setDataCoins(coinsData.dataCoins || []);
      setDataCoinsSecondary(coinsData.dataCoins_secondary || []);

      const statusRes = await fetch(`${API_BASE_URL}/bot/status`);
      const statusData = await statusRes.json();
      setBotStatus(statusData);

      // const profitCount = await fetch(`${API_BASE_URL}/bot/profitable-count`);
      // const countData = await profitCount.json();
      // setProfitCount(countData);

      // پس از دریافت اولیه، شروع به فچ متناوب کن
      setLoading(false);
    } catch (error) {
      console.error("Error fetching initial data:", error);
      setLoading(false);
    }
  }, []);

  // 2. به‌روزرسانی لحظه‌ای بازار و وضعیت بات/کوین‌ها
  const fetchDataLoop = useCallback(async () => {
    try {
      // API /api/nobitex (market and wallets)
      const nobitexRes = await fetch(`${API_BASE_URL}/nobitex`);

      const nobitexData = await nobitexRes.json();
      setMarketData(nobitexData);

      // API /api/bot/coins (که سرور خودش now_pcs و nowPrice را آپدیت می‌کند)
      const coinsRes = await fetch(`${API_BASE_URL}/bot/coins`);
      const coinsData = await coinsRes.json();
      setDataCoins(coinsData.dataCoins || []);
      setDataCoinsSecondary(coinsData.dataCoins_secondary || []);

      // API /api/bot/status
      const statusRes = await fetch(`${API_BASE_URL}/bot/status`);
      const statusData = await statusRes.json();
      setBotStatus(statusData);

      // شبیه‌سازی منطق PercentageCalculation برای UI (اگر می‌خواهید آن را در فرانت ببینید)
      if (nobitexData.stats) {
        const usdtPrices = Object.fromEntries(
          Object.entries(nobitexData.stats.stats || {})
            .filter(([symbol, info]) => symbol.endsWith("-usdt") && info.mark)
            .map(([symbol, info]) => [
              symbol.split("-")[0],
              parseFloat(info.mark),
            ])
        );

        const coinsSnapshot = coinsData.dataCoins.map((c) => ({
          ...c,
          nowPrice: usdtPrices[c.nameCoin]
            ? parseFloat(usdtPrices[c.nameCoin])
            : c.nowPrice,
        }));

        const calc = (A_price, B_price, A_buy_sell_price, B_buy_sell_price) =>
          (A_price / A_buy_sell_price / (B_price / B_buy_sell_price) - 1) * 100;

        const Data_percent = [];

        for (let i = 0; i < coinsSnapshot.length; i++) {
          for (let j = i + 1; j < coinsSnapshot.length; j++) {
            const a = coinsSnapshot[i];
            const b = coinsSnapshot[j];
            if (a.nowPrice > 0 && b.nowPrice > 0) {
              const percent = calc(
                a.nowPrice,
                b.nowPrice,
                a.buy_sell_price,
                b.buy_sell_price
              );
              Data_percent.push({
                label: `${a.nameCoin} / ${b.nameCoin}`,
                coinA: a,
                coinB: b,
                percent,
              });
            }
          }
        }

        Data_percent.sort((x, y) => Math.abs(y.percent) - Math.abs(x.percent));
        setTradingPairs(Data_percent);

        // پیدا کردن بهترین جفت مطابق منطق سرور
        const best = Data_percent.find((item) => {
          const sellCandidate = item.percent > 0 ? item.coinA : item.coinB;
          const buyCandidate = item.percent > 0 ? item.coinB : item.coinA;
          const pairThreshold = Math.max(
            sellCandidate.threshold,
            buyCandidate.threshold
          );

          return (
            Math.abs(item.percent) > pairThreshold &&
            sellCandidate.sell_mode === true &&
            buyCandidate.buy_mode === true
          );
        });
        setBestTrade(best);
      }
    } catch (error) {
      console.error("Error in data loop:", error);
    }
  }, []);

  const fetchLogs = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/bot/logs`);
      const data = await res.json();
      setLogs(data.logs || []);
    } catch (error) {
      console.log("Error fetching logs:", error);
    }
  };

  const tokenGrowthIndex = () => {
    if (!dataCoins || dataCoins.length === 0) return 0;

    const totalRatio = dataCoins.reduce((sum, coin) => {
      return sum + coin.now_pcs / coin.first_pcs;
    }, 0);

    const baseline = dataCoins.length;

    const growth = totalRatio - baseline;

    const percent = (growth / baseline) * 100;

    return {
      totalRatio: totalRatio.toFixed(4),
      growth: growth.toFixed(4),
      percent: percent.toFixed(2),
    };
  };

  const tgi = tokenGrowthIndex();

  useEffect(() => {
    fetchLogs();
    const interval = setInterval(fetchLogs, 2000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    fetchInitialData();
    // اینتروال برای به‌روزرسانی داده‌ها
    const intervalId = setInterval(fetchDataLoop, 1000); // هر 1 ثانیه

    return () => clearInterval(intervalId);
  }, [fetchInitialData, fetchDataLoop]);

  // تابع کنترل بات (Start/Stop)
  const handleBotControl = async (action) => {
    try {
      const res = await fetch(`${API_BASE_URL}/bot/${action}`, {
        method: "POST",
      });
      const data = await res.json();
      console.log(`Bot ${action} response:`, data);
      // فورا وضعیت بات را دوباره فچ کن
      fetchDataLoop();
    } catch (error) {
      console.error(`Error controlling bot (${action}):`, error);
    }
  };


  const handleManualTrade = async (item) => {
    try {
      // تعیین فروشنده و خریدار براساس درصد (مثل بقیهٔ UI)
      const sellCandidate = item.percent > 0 ? item.coinA : item.coinB;
      const buyCandidate  = item.percent > 0 ? item.coinB : item.coinA;
  
      // جلوگیری از فشار دادن همزمان
      if (botStatus.tradeLock || botStatus.isTrading) {
        alert("در حال حاضر ترید ممکن نیست (locked یا busy).");
        return;
      }
  
      // درخواست شروع ترید دستی
      const res = await fetch(`${API_BASE_URL}/bot/manual-trade`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ coinA: sellCandidate.nameCoin, coinB: buyCandidate.nameCoin })
      });
  
      const data = await res.json();
      if (!res.ok) {
        alert("خطا: " + (data.error || JSON.stringify(data)));
        return;
      }
  
      // اطلاع کاربر
      if (data.status === "accepted") {
        alert("ترید شروع شد — لاگ‌ها را برای نتیجه چک کن.");
        // بروزرسانی سریع UI و لاگ‌ها
        setTimeout(() => {
          fetchLogs();
          fetchDataLoop();
        }, 800);
      } else {
        alert("پاسخ غیرمنتظره از سرور: " + JSON.stringify(data));
      }
    } catch (err) {
      console.error("Manual trade error:", err);
      alert("خطا در ارسال درخواست ترید دستی: " + (err.message || err));
    }
  };

  

  // محاسبه A/B/C/D
  const calculateABCD = () => {
    const allCoins = [...dataCoins, ...dataCoinsSecondary];

    const A = allCoins.reduce(
      (sum, c) => sum + c.first_pcs * (c.firstPrice || 0),
      0
    );
    const B = allCoins.reduce(
      (sum, c) => sum + (c.now_pcs || 0) * (c.nowPrice || 0),
      0
    );
    const C = allCoins.reduce(
      (sum, c) => sum + c.first_pcs * (c.nowPrice || 0),
      0
    );
    const D = allCoins.reduce(
      (sum, c) => sum + (c.now_pcs || 0) * (c.firstPrice || 0),
      0
    );

    return {
      A: A.toFixed(10), // حفظ دقت بالا
      B: B.toFixed(10), // حفظ دقت بالا
      C: C.toFixed(2),
      D: D.toFixed(2),
    };
  };

  const abcd = calculateABCD();
  const balanceDifference = (abcd.B - abcd.A).toFixed(2);
  const tradeOpportunityCount = tradingPairs.filter((p) => {
    const sellCandidate = p.percent > 0 ? p.coinA : p.coinB;
    const buyCandidate = p.percent > 0 ? p.coinB : p.coinA;
    const pairThreshold = Math.max(
      sellCandidate.threshold,
      buyCandidate.threshold
    );
    return (
      Math.abs(p.percent) > pairThreshold &&
      sellCandidate.sell_mode &&
      buyCandidate.buy_mode
    );
  }).length;

  const updateThreshold = async (nameCoin, type, newValue) => {
    try {
      await fetch(`${API_BASE_URL}/bot/update-threshold`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          nameCoin,
          type,
          value: newValue,
        }),
      });

      // 🚀 این خیلی مهمه: بلافاصله داده‌ها را آپدیت کن
      await fetchDataLoop();

      // ⛔ 300ms تأخیر برای جلوگیری از override توسط interval 1s
      setTimeout(fetchDataLoop, 300);
    } catch (err) {
      console.error("Error updating threshold", err);
    }
  };

  if (isMobile) {
    // نسخه موبایل
    return (
      <div style={{ direction: "ltr" }}>
        {/* Header */}

        <div style={{ direction: "ltr" }}>
     

        <div
          style={{
            display: "flex",
            gap: "8px",
            alignItems: "center",
          }}
        ></div>
      </div>
        <div style={{ direction: "ltr" }}>
                         {/* START button */}
                         <button
                  style={{
                    marginTop: "30px" ,
                    marginLeft: "120px",
                    padding: "8px 18px",
                    fontSize: "20px",
                    fontWeight: "900",
                    color: "white",
                    border: "none",
                    borderRadius: "10px",
                    cursor: "pointer",
                    transition: "all 0.25s ease",
                    opacity: botStatus.isRunning || botStatus.isTrading ? 0.5 : 1,
  
                    background: "linear-gradient(135deg, #2ecc71, #27ae60)", // سبز زیبا
                    boxShadow: "0 3px 8px rgba(0, 200, 120, 0.35)",
                  }}
                  onMouseOver={(e) => {
                    if (botStatus.isRunning || botStatus.isTrading) return;
                    e.currentTarget.style.transform = "scale(1.06)";
                    e.currentTarget.style.boxShadow =
                      "0 5px 12px rgba(0, 200, 120, 0.55)";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                    e.currentTarget.style.boxShadow =
                      "0 3px 8px rgba(0, 200, 120, 0.35)";
                  }}
                  onClick={() => handleBotControl("start")}
                  disabled={botStatus.isRunning || botStatus.isTrading}
                >
                  Start
                </button>
  
                {/* STOP button */}
                <button
                  style={{
                    marginLeft: "20px",
                    padding: "8px 18px",
                    fontSize: "20px",
                    fontWeight: "900",
                    color: "white",
                    border: "none",
                    borderRadius: "10px",
                    cursor: "pointer",
                    transition: "all 0.25s ease",
                    opacity: !botStatus.isRunning ? 0.5 : 1,
  
                    background: "linear-gradient(135deg, #ff4d4d, #cc0000)", // قرمز زیبا
                    boxShadow: "0 3px 8px rgba(255, 0, 0, 0.35)",
                  }}
                  onMouseOver={(e) => {
                    if (!botStatus.isRunning) return;
                    e.currentTarget.style.transform = "scale(1.06)";
                    e.currentTarget.style.boxShadow =
                      "0 5px 12px rgba(255, 0, 0, 0.55)";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                    e.currentTarget.style.boxShadow =
                      "0 3px 8px rgba(255, 0, 0, 0.35)";
                  }}
                  onClick={() => handleBotControl("stop")}
                  disabled={!botStatus.isRunning}
                >
                  Stop
                </button>
          <p style={{ marginLeft: "100px", color: "#000", fontSize: "20px" }}>
                Count of profitable trade :
                <span
                  style={{
                    fontWeight: "bold",
                    color: "#000000",
                    marginLeft: "20px",
                  }}
                >
                  {botStatus.tradeCount || 0}
                </span>
              </p>
  
              <p style={{ marginLeft: "100px", color: "#000", fontSize: "20px" }}>
                lock trade :
                <span
                  style={{
                    marginLeft: "20px",
                    fontWeight: "bold",
                    color: botStatus.tradeLock ? "#000000" : "#000",
                  }}
                >
                  {botStatus.tradeLock ? "Lock" : "Open"}
                </span>
              </p>
  
              <p style={{ marginLeft: "100px", color: "#000", fontSize: "20px" }}>
                best percent trade :
                <span
                  style={{
                    fontWeight: "bold",
                    color: "#000",
                    marginLeft: "20px",
                  }}
                >
                  {bestTrade ? bestTrade.label : "N/A"}
                </span>
              </p>
  
     
        </div>
  
        {/* Summary Section */}
        <div
          style={{
            display: "flex",
            marginBottom: "10px",
            gap: "1px",
          }}
        >
          {/* Left Small Box */}
          <div style={{ width: "20%" }}>
            <div
              style={{
                padding: "16px",
                borderRadius: "6px",
                backgroundColor: "#ffffff",
                // boxShadow: "0 0 4px rgba(0,0,0,0.4)",
              }}
            >
              <div
                style={{
                  display: "flex",
        
                  gap: "8px",
                  marginBottom: "16px",
                }}
              >

              </div>
  

            </div>
  
            {/* Right Table */}
  
            <div>
              <table
                style={{
                  marginLeft: "80px",
                  borderCollapse: "separate",
                  width: "400px",
                  textAlign: "center",
                }}
              >
                <thead>
                  <tr style={{ background: "#e6f2ff" }}>
                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                      Pair
                    </th>
                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                      Percent
                    </th>
                  </tr>
                </thead>
  
                <tbody>
                  {tradingPairs.slice(0, 100).map((item, index) => {
                    // تعیین فروشنده و خریدار براساس درصد
                    const sellCandidate =
                      item.percent > 0 ? item.coinA : item.coinB;
                    const buyCandidate =
                      item.percent > 0 ? item.coinB : item.coinA;
  
                    // بررسی شرایط
                    const isCandidate =
                      sellCandidate.sell_mode &&
                      buyCandidate.buy_mode &&
                      Math.abs(item.percent) < 10;
  
                    return (
                      <tr
                        key={index}
                        style={{
                          backgroundColor:
                            item.label === bestTrade?.label
                              ? "rgba(255, 230, 150, 0.7)"
                              : "white",
                        }}
                      >
                        <td
                          style={{
                            border: "1px solid #ccc",
                            padding: "6px",
                            fontSize: "22px",
                          }}
                        >
                          <span
                            style={{
                              color:
                                sellCandidate.nameCoin === item.coinA.nameCoin
                                  ? sellCandidate.sell_mode
                                    ? "#0066ff"
                                    : "#4d4d4d" // فروشنده
                                  : buyCandidate.buy_mode
                                  ? "#9933ff"
                                  : "#4d4d4d", // خریدار
                              fontWeight:
                                sellCandidate.nameCoin === item.coinA.nameCoin ||
                                buyCandidate.nameCoin === item.coinA.nameCoin
                                  ? "bold"
                                  : "normal",
                            }}
                          >
                            {item.coinA.nameCoin.toUpperCase()}
                          </span>
  
                          {" / "}
  
                          <span
                            style={{
                              color:
                                sellCandidate.nameCoin === item.coinB.nameCoin
                                  ? sellCandidate.sell_mode
                                    ? "#0066ff"
                                    : "#4d4d4d" // فروشنده
                                  : buyCandidate.buy_mode
                                  ? "#9933ff"
                                  : "#4d4d4d", // خریدار
                              fontWeight:
                                sellCandidate.nameCoin === item.coinB.nameCoin ||
                                buyCandidate.nameCoin === item.coinB.nameCoin
                                  ? "bold"
                                  : "normal",
                            }}
                          >
                            {item.coinB.nameCoin.toUpperCase()}
                          </span>
  
                          {isCandidate && (
                            <span style={{ marginLeft: "8px", color: "orange" }}>
                              ✔
                            </span>
                          )}
                        </td>
  
                        <td
                          style={{
                            border: "1px solid #ccc",
                            padding: "6px",
                            fontSize: "22px",
                            fontWeight: "bold",
                            color: item.percent > 0 ? "green" : "red",
                          }}
                        >
                          {formatNumber(item.percent, 4)}%
                        </td>
                        <td style={{ border: "1px solid #ccc", padding: "6px" }}>
                      <button
                      onClick={() => handleManualTrade(item)}
                      disabled={botStatus.tradeLock || botStatus.isTrading}
                      style={{
                        padding: "6px 14px",
                        borderRadius: "8px",
                        cursor: botStatus.tradeLock || botStatus.isTrading ? "not-allowed" : "pointer",
                        background: botStatus.tradeLock || botStatus.isTrading ? "#7aa8f7" : "#1e88e5",
                        border: "none",
                        color: "white",
                        fontWeight: "600",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                        transition: "0.2s",
                      }}
                      onMouseOver={e => {
                        if (!botStatus.tradeLock && !botStatus.isTrading)
                          e.currentTarget.style.background = "#1565c0";
                      }}
                      onMouseOut={e => {
                        if (!botStatus.tradeLock && !botStatus.isTrading)
                          e.currentTarget.style.background = "#1e88e5";
                      }}
                    >
                      Trade
                    </button>

                    </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>

  
          {/* MAIN COINS LIST (SELL MODE) */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: "1800px",
              marginTop: "10px",
              marginLeft: "400px",
            }}
          >

            <ul style={{ width: "100%", maxWidth: "1800px", padding: 0 }}>
              {dataCoins
                .filter((coin) => coin.sell_mode)
                .map((coin, index) => (
                  <li
                    key={index}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "10px",
                      marginBottom: "10px",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                      backgroundColor: "#f0f8ff",
                    }}
                  >
                    <span style={{ fontWeight: "bold", color: "#43f" }}>
                      {coin.nameCoin.toUpperCase()}
                    </span>
  
                    <span>
                      Now Price: <b>{coin.nowPrice.toFixed(4)}</b> $
                    </span>
  
                    <span>
                      Now pcs: <b>{coin.now_pcs.toFixed(4)}</b>
                    </span>
  
                    <span>
                      First Price: <b>{coin.firstPrice.toFixed(4)}</b>
                    </span>
  
                    <span>
                      First pcs: <b>{coin.first_pcs.toFixed(4)}</b>
                    </span>
  
                    <span>
                      Buy/Sell Price: <b>{coin.buy_sell_price.toFixed(4)}</b>
                    </span>
  
                    <span>
                      nowPrice / (Buy/Sell):{" "}
                      <b>{(coin.nowPrice / coin.buy_sell_price).toFixed(4)}</b>
                    </span>
  
                    <span>
                      threshold_buy:
                      <button
                        style={{ marginLeft: "5px" }}
                        onClick={() =>
                          updateThreshold(
                            coin.nameCoin,
                            "buy",
                            coin.threshold_buy - 0.5
                          )
                        }
                      >
                        -
                      </button>
                      <b style={{ margin: "0 6px" }}>
                        {coin.threshold_buy.toFixed(2)}
                      </b>
                      <button
                        onClick={() =>
                          updateThreshold(
                            coin.nameCoin,
                            "buy",
                            coin.threshold_buy + 0.5
                          )
                        }
                      >
                        +
                      </button>
                    </span>
  
                    <span>
                      threshold_sell:
                      <button
                        style={{ marginLeft: "5px" }}
                        onClick={() =>
                          updateThreshold(
                            coin.nameCoin,
                            "sell",
                            coin.threshold_sell - 0.5
                          )
                        }
                      >
                        -
                      </button>
                      <b style={{ margin: "0 6px" }}>
                        {coin.threshold_sell.toFixed(2)}
                      </b>
                      <button
                        onClick={() =>
                          updateThreshold(
                            coin.nameCoin,
                            "sell",
                            coin.threshold_sell + 0.5
                          )
                        }
                      >
                        +
                      </button>
                    </span>
  
                    <span>
                      Profit:{" "}
                      <b>
                        {(
                          (coin.nowPrice - coin.buy_sell_price) *
                          coin.now_pcs
                        ).toFixed(4)}
                      </b>
                    </span>
  
                    <span>
                     
                      <b>{( coin.nowPrice * coin.now_pcs ).toFixed(4)}</b>
                      {" "}   $
                    </span>
                  </li>
                ))}
  
              {/* MAIN COINS LIST (BUY MODE) */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  width: "1800px",
                  marginTop: "10px",
                }}
              >
                <ul style={{ width: "100%", maxWidth: "1800px", padding: 0 }}>
                  {dataCoins
                    .filter((coin) => !coin.sell_mode)
                    .map((coin, index) => (
                      <li
                        key={index}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "10px",
                          marginBottom: "10px",
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                          backgroundColor: "#fcc2e3",
                        }}
                      >
                        <span style={{ fontWeight: "bold", color: "#43f" }}>
                          {coin.nameCoin.toUpperCase()}
                        </span>
  
                        <span>
                          Now Price: <b>{coin.nowPrice.toFixed(4)}</b> $
                        </span>
  
                        <span>
                          Now pcs: <b>{coin.now_pcs.toFixed(4)}</b>
                        </span>
  
                        <span>
                          First Price: <b>{coin.firstPrice.toFixed(4)}</b>
                        </span>
  
                        <span>
                          First pcs: <b>{coin.first_pcs.toFixed(4)}</b>
                        </span>
  
                        <span>
                          Buy/Sell Price: <b>{coin.buy_sell_price.toFixed(4)}</b>
                        </span>
  
                        <span>
                          nowPrice / (Buy/Sell):{" "}
                          <b>
                            {(coin.nowPrice / coin.buy_sell_price).toFixed(4)}
                          </b>
                        </span>
  
                        <span>
                          threshold_buy:
                          <button
                            style={{ marginLeft: "5px" }}
                            onClick={() =>
                              updateThreshold(
                                coin.nameCoin,
                                "buy",
                                coin.threshold_buy - 0.5
                              )
                            }
                          >
                            -
                          </button>
                          <b style={{ margin: "0 6px" }}>
                            {coin.threshold_buy.toFixed(2)}
                          </b>
                          <button
                            onClick={() =>
                              updateThreshold(
                                coin.nameCoin,
                                "buy",
                                coin.threshold_buy + 0.5
                              )
                            }
                          >
                            +
                          </button>
                        </span>
  
                        <span>
                          threshold_sell:
                          <button
                            style={{ marginLeft: "5px" }}
                            onClick={() =>
                              updateThreshold(
                                coin.nameCoin,
                                "sell",
                                coin.threshold_sell - 0.5
                              )
                            }
                          >
                            -
                          </button>
                          <b style={{ margin: "0 6px" }}>
                            {coin.threshold_sell.toFixed(2)}
                          </b>
                          <button
                            onClick={() =>
                              updateThreshold(
                                coin.nameCoin,
                                "sell",
                                coin.threshold_sell + 0.5
                              )
                            }
                          >
                            +
                          </button>
                        </span>
  
                        <span>
                          Profit:{" "}
                          <b>
                            {(
                              (coin.nowPrice - coin.buy_sell_price) *
                              coin.now_pcs
                            ).toFixed(4)}
                          </b>
                        </span>
  
                        <span>
                     
                     <b>{( coin.nowPrice * coin.now_pcs ).toFixed(4)}</b>
                     {" "}   $
                   </span>
                   
                      </li>
                    ))}
                </ul>
              </div>
              {/* SECONDARY COINS */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  width: "1700px",
                  marginTop: "10px",
                }}
              >
                <ul style={{ width: "100%", maxWidth: "1200px", padding: 0 }}>
                  {dataCoinsSecondary.map((coin, index) => (
                    <li
                      key={index}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "10px",
                        marginBottom: "10px",
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                        backgroundColor: "#fcc2e3",
                      }}
                    >
                      <span style={{ fontWeight: "bold", color: "#0004f5" }}>
                        {coin.nameCoin.toUpperCase()}
                      </span>
  
                      <span>
                        Now Price: <b>{coin.nowPrice}</b> $
                      </span>
  
                      <span>
                        Now pcs: <b>{coin.now_pcs}</b>
                      </span>
  
                      <span>
                        First Price: <b>{coin.firstPrice}</b>
                      </span>
  
                      <span>
                        First pcs: <b>{coin.first_pcs}</b>
                      </span>
  
                      <span>
                        Buy/Sell Price: <b>{coin.buy_sell_price}</b>
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
              <div
                style={{
                  width: "1700px",
                  height: "200px",
                  overflowY: "scroll",
                  background: "#111",
                  color: "#0f0",
                  padding: "10px",
                  borderRadius: "8px",
                  border: "1px solid #444",
                  fontFamily: "monospace",
                  fontSize: "12px",
                }}
              >
                {logs.map((line, i) => (
                  <div key={i}>{line}</div>
                ))}
              </div>
  
              {/* ABCD Summary */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  paddingTop: "16px",
                  // borderTop: "1px solid #374151",
                  marginTop: "20px",
                  marginLeft: "100px",
                }}
              >
                <div style={{ width: "80%" }}>
                  <p style={{ fontSize: "25px", color: "#000" }}>
                    <span style={{ fontSize: "20px" }}>
                      {" "}
                      ( ارزش اولیه )
                      .............................................................
                      A ={" "}
                    </span>
                    <span style={{ fontSize: "24px" }}>∑</span>
                    <span style={{ fontSize: "18px" }}>
                      {" "}
                      ( price_first * pcs_first ) ={" "}
                    </span>
                    <span style={{ color: "#000", fontWeight: "bold" }}>
                      {abcd.A} $
                    </span>
                  </p>
  
                  <p style={{ fontSize: "25px", color: "#000" }}>
                    <span style={{ fontSize: "20px" }}>
                      {" "}
                      ( ارزش فعلی بعد از تریده )
                      ...............................................B ={" "}
                    </span>
                    <span style={{ fontSize: "24px" }}>∑</span>
                    <span style={{ fontSize: "18px" }}>
                      {" "}
                      ( price_now * pcs_now ) ={" "}
                    </span>
                    <span style={{ color: "#000", fontWeight: "bold" }}>
                      {abcd.B} $
                    </span>
                  </p>
  
                  <p style={{ fontSize: "25px", color: "#000" }}>
                    <span style={{ fontSize: "20px" }}>
                      {" "}
                      ( اگر هیچ تریدی نمی‌کردید )
                      ............................................. C ={" "}
                    </span>
                    <span style={{ fontSize: "24px" }}>∑</span>
                    <span style={{ fontSize: "18px" }}>
                      {" "}
                      ( price_now * pcs_first ) ={" "}
                    </span>
                    <span style={{ color: "#000", fontWeight: "bold" }}>
                      {abcd.C} $
                    </span>
                  </p>
  
                  <p style={{ fontSize: "25px", color: "#000" }}>
                    <span style={{ fontSize: "20px" }}>
                      {" "}
                      (اگر امروز می‌خواستید همین مقدار الان را با قیمت اولیه
                      بخرید)..... D =
                    </span>
                    <span style={{ fontSize: "24px" }}>∑</span>
                    <span style={{ fontSize: "18px" }}>
                      {" "}
                      ( price_first * pcs_now ) ={" "}
                    </span>
                    <span style={{ color: "#000", fontWeight: "bold" }}>
                      {abcd.D} $
                    </span>
                  </p>
                </div>
  
                <div
                  style={{
                    marginTop: "20px",
                    padding: "16px",
                    border: "1px solid #ccc",
                    borderRadius: "12px",
                    background: "#fff",
                    width: "600px",
                  }}
                >
                  <h2 style={{ marginBottom: "16px" }}>
                    Token Growth (now_pcs / first_pcs)
                  </h2>
  
                  <ul style={{ listStyle: "none", padding: 0 }}>
                    {dataCoins.map((coin, index) => {
                      const ratio = coin.now_pcs / coin.first_pcs;
  
                      return (
                        <li
                          key={index}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "8px",
                            marginBottom: "6px",
                            borderBottom: "1px solid #eee",
                            fontSize: "18px",
                          }}
                        >
                          <span style={{ fontWeight: "bold" }}>
                            {coin.nameCoin.toUpperCase()}
                          </span>
  
                          <span
                            style={{
                              color:
                                ratio > 1 ? "green" : ratio < 1 ? "red" : "#333",
                              fontWeight: "bold",
                            }}
                          >
                            {ratio.toFixed(4)}
                          </span>
                        </li>
                      );
                    })}
                    <p
                      style={{
                        fontSize: "22px",
                        color: tgi.percent >= 0 ? "green" : "red",
                      }}
                    >
                      Token Growth Index: <b>{tgi.percent}%</b>
                    </p>
                  </ul>
  
                  {/* TOTAL RATIO */}
                  <div
                    style={{
                      marginTop: "16px",
                      paddingTop: "10px",
                      borderTop: "2px solid #333",
                      fontSize: "20px",
                      fontWeight: "bold",
                    }}
                  >
                    Total Ratio:{" "}
                    {dataCoins
                      .reduce(
                        (sum, coin) => sum + coin.now_pcs / coin.first_pcs,
                        0
                      )
                      .toFixed(2)}
                  </div>
                </div>
              </div>
            </ul>
          </div>
          <p>.</p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ direction: "ltr" }}>
      {/* Header */}
      <div style={{ direction: "ltr" }}>
        
                <h1
                style={{
                  marginTop: "30px",
                  marginLeft: "100px",
                  fontSize: "34px",
                  color:"red"
                }}
              >
                *  *  *   *   **  **  **  **                      Hadi  ...!!!   bizahmat be server ye sar bezan ** *** ****
              </h1>

        <div
          style={{
            display: "flex",
            gap: "8px",
            alignItems: "center",
          }}
        ></div>
      </div>

      {/* Summary Section */}
      <div
        style={{
          display: "flex",
          marginBottom: "10px",
          gap: "1px",
        }}
      >
        {/* Left Small Box */}
        <div style={{ width: "20%" }}>
          <div
            style={{
              padding: "16px",
              borderRadius: "6px",
              backgroundColor: "#ffffff",
              // boxShadow: "0 0 4px rgba(0,0,0,0.4)",
            }}
          >
            <div
              style={{
                display: "flex",
                marginTop: "20px",
                gap: "8px",
                marginBottom: "16px",
              }}
            >
              {/* START button */}
              <button
                style={{
                  marginLeft: "120px",
                  padding: "8px 18px",
                  fontSize: "20px",
                  fontWeight: "900",
                  color: "white",
                  border: "none",
                  borderRadius: "10px",
                  cursor: "pointer",
                  transition: "all 0.25s ease",
                  opacity: botStatus.isRunning || botStatus.isTrading ? 0.5 : 1,

                  background: "linear-gradient(135deg, #2ecc71, #27ae60)", // سبز زیبا
                  boxShadow: "0 3px 8px rgba(0, 200, 120, 0.35)",
                }}
                onMouseOver={(e) => {
                  if (botStatus.isRunning || botStatus.isTrading) return;
                  e.currentTarget.style.transform = "scale(1.06)";
                  e.currentTarget.style.boxShadow =
                    "0 5px 12px rgba(0, 200, 120, 0.55)";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.boxShadow =
                    "0 3px 8px rgba(0, 200, 120, 0.35)";
                }}
                onClick={() => handleBotControl("start")}
                disabled={botStatus.isRunning || botStatus.isTrading}
              >
                Start
              </button>

              {/* STOP button */}
              <button
                style={{
                  marginLeft: "20px",
                  padding: "8px 18px",
                  fontSize: "20px",
                  fontWeight: "900",
                  color: "white",
                  border: "none",
                  borderRadius: "10px",
                  cursor: "pointer",
                  transition: "all 0.25s ease",
                  opacity: !botStatus.isRunning ? 0.5 : 1,

                  background: "linear-gradient(135deg, #ff4d4d, #cc0000)", // قرمز زیبا
                  boxShadow: "0 3px 8px rgba(255, 0, 0, 0.35)",
                }}
                onMouseOver={(e) => {
                  if (!botStatus.isRunning) return;
                  e.currentTarget.style.transform = "scale(1.06)";
                  e.currentTarget.style.boxShadow =
                    "0 5px 12px rgba(255, 0, 0, 0.55)";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.boxShadow =
                    "0 3px 8px rgba(255, 0, 0, 0.35)";
                }}
                onClick={() => handleBotControl("stop")}
                disabled={!botStatus.isRunning}
              >
                Stop
              </button>
            </div>

            <p style={{ marginLeft: "100px", color: "#000", fontSize: "20px" }}>
              Count of profitable trades :
              <span
                style={{
                  fontWeight: "bold",
                  color: "#000000",
                  marginLeft: "20px",
                }}
              >
                {botStatus.tradeCount || 0}
              </span>
            </p>

            <p style={{ marginLeft: "100px", color: "#000", fontSize: "20px" }}>
              lock trade :
              <span
                style={{
                  marginLeft: "20px",
                  fontWeight: "bold",
                  color: botStatus.tradeLock ? "#000000" : "#000",
                }}
              >
                {botStatus.tradeLock ? "Lock" : "Open"}
              </span>
            </p>

            <p style={{ marginLeft: "100px", color: "#000", fontSize: "20px" }}>
              best percent trade :
              <span
                style={{
                  fontWeight: "bold",
                  color: "#000",
                  marginLeft: "20px",
                }}
              >
                {bestTrade ? bestTrade.label : "N/A"}
              </span>
            </p>
          </div>

          {/* Right Table */}

          <div>
            <table
              style={{
                marginLeft: "80px",
                borderCollapse: "separate",
                width: "400px",
                textAlign: "center",
              }}
            >
              <thead>
                <tr style={{ background: "#e6f2ff" }}>
                  <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                    Pair
                  </th>
                  <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                    Percent
                  </th>
                </tr>
              </thead>

              <tbody>
                {tradingPairs.slice(0, 100).map((item, index) => {
                  // تعیین فروشنده و خریدار براساس درصد
                  const sellCandidate =
                    item.percent > 0 ? item.coinA : item.coinB;
                  const buyCandidate =
                    item.percent > 0 ? item.coinB : item.coinA;

                  // بررسی شرایط
                  const isCandidate =
                    sellCandidate.sell_mode &&
                    buyCandidate.buy_mode &&
                    Math.abs(item.percent) < 10;

                  return (
                    <tr
                      key={index}
                      style={{
                        backgroundColor:
                          item.label === bestTrade?.label
                            ? "rgba(255, 230, 150, 0.7)"
                            : "white",
                      }}
                    >
                      <td
                        style={{
                          border: "1px solid #ccc",
                          padding: "6px",
                          fontSize: "22px",
                        }}
                      >
                        <span
                          style={{
                            color:
                              sellCandidate.nameCoin === item.coinA.nameCoin
                                ? sellCandidate.sell_mode
                                  ? "#0066ff"
                                  : "#4d4d4d" // فروشنده
                                : buyCandidate.buy_mode
                                ? "#9933ff"
                                : "#4d4d4d", // خریدار
                            fontWeight:
                              sellCandidate.nameCoin === item.coinA.nameCoin ||
                              buyCandidate.nameCoin === item.coinA.nameCoin
                                ? "bold"
                                : "normal",
                          }}
                        >
                          {item.coinA.nameCoin.toUpperCase()}
                        </span>

                        {" / "}

                        <span
                          style={{
                            color:
                              sellCandidate.nameCoin === item.coinB.nameCoin
                                ? sellCandidate.sell_mode
                                  ? "#0066ff"
                                  : "#4d4d4d" // فروشنده
                                : buyCandidate.buy_mode
                                ? "#9933ff"
                                : "#4d4d4d", // خریدار
                            fontWeight:
                              sellCandidate.nameCoin === item.coinB.nameCoin ||
                              buyCandidate.nameCoin === item.coinB.nameCoin
                                ? "bold"
                                : "normal",
                          }}
                        >
                          {item.coinB.nameCoin.toUpperCase()}
                        </span>

                        {isCandidate && (
                          <span style={{ marginLeft: "8px", color: "orange" }}>
                            ✔
                          </span>
                        )}
                      </td>

                      <td
                        style={{
                          border: "1px solid #ccc",
                          padding: "6px",
                          fontSize: "22px",
                          fontWeight: "bold",
                          color: item.percent > 0 ? "green" : "red",
                        }}
                      >
                        {formatNumber(item.percent, 4)}%
                      </td>

                      <td style={{ border: "1px solid #ccc", padding: "6px" }}>
                      <button
                      onClick={() => handleManualTrade(item)}
                      disabled={botStatus.tradeLock || botStatus.isTrading}
                      style={{
                        padding: "6px 14px",
                        borderRadius: "8px",
                        cursor: botStatus.tradeLock || botStatus.isTrading ? "not-allowed" : "pointer",
                        background: botStatus.tradeLock || botStatus.isTrading ? "#7aa8f7" : "#1e88e5",
                        border: "none",
                        color: "white",
                        fontWeight: "600",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                        transition: "0.2s",
                      }}
                      onMouseOver={e => {
                        if (!botStatus.tradeLock && !botStatus.isTrading)
                          e.currentTarget.style.background = "#1565c0";
                      }}
                      onMouseOut={e => {
                        if (!botStatus.tradeLock && !botStatus.isTrading)
                          e.currentTarget.style.background = "#1e88e5";
                      }}
                    >
                      Trade
                    </button>

                    </td>

                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        {/* MAIN COINS LIST (SELL MODE) */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            width: "1800px",
            marginTop: "10px",
            marginLeft: "40px",
          }}
        >
          <ul style={{ width: "100%", maxWidth: "1800px", padding: 0 }}>
            {dataCoins
              .filter((coin) => coin.sell_mode)
              .map((coin, index) => (
                <li
                  key={index}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "10px",
                    marginBottom: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    backgroundColor: "#f0f8ff",
                  }}
                >
                  <span style={{ fontWeight: "bold", color: "#43f" }}>
                    {coin.nameCoin.toUpperCase()}
                  </span>

                  <span>
                    Now Price: <b>{coin.nowPrice.toFixed(4)}</b> $
                  </span>

                  <span>
                    Now pcs: <b>{coin.now_pcs.toFixed(4)}</b>
                  </span>

                  <span>
                    First Price: <b>{coin.firstPrice.toFixed(4)}</b>
                  </span>

                  <span>
                    First pcs: <b>{coin.first_pcs.toFixed(4)}</b>
                  </span>

                  <span>
                    Buy/Sell Price: <b>{coin.buy_sell_price.toFixed(4)}</b>
                  </span>

                  <span>
                    nowPrice / (Buy/Sell):{" "}
                    <b>{(coin.nowPrice / coin.buy_sell_price).toFixed(4)}</b>
                  </span>

                  <span>
                    threshold_buy:
                    <button
                      style={{ marginLeft: "5px" }}
                      onClick={() =>
                        updateThreshold(
                          coin.nameCoin,
                          "buy",
                          coin.threshold_buy - 0.5
                        )
                      }
                    >
                      -
                    </button>
                    <b style={{ margin: "0 6px" }}>
                      {coin.threshold_buy.toFixed(2)}
                    </b>
                    <button
                      onClick={() =>
                        updateThreshold(
                          coin.nameCoin,
                          "buy",
                          coin.threshold_buy + 0.5
                        )
                      }
                    >
                      +
                    </button>
                  </span>

                  <span>
                    threshold_sell:
                    <button
                      style={{ marginLeft: "5px" }}
                      onClick={() =>
                        updateThreshold(
                          coin.nameCoin,
                          "sell",
                          coin.threshold_sell - 0.5
                        )
                      }
                    >
                      -
                    </button>
                    <b style={{ margin: "0 6px" }}>
                      {coin.threshold_sell.toFixed(2)}
                    </b>
                    <button
                      onClick={() =>
                        updateThreshold(
                          coin.nameCoin,
                          "sell",
                          coin.threshold_sell + 0.5
                        )
                      }
                    >
                      +
                    </button>
                  </span>

                  <span>
                    Profit:{" "}
                    <b>
                      {(
                        (coin.nowPrice - coin.buy_sell_price) *
                        coin.now_pcs
                      ).toFixed(4)}
                    </b>
                  </span>

                  <span>
                   
                    <b>{( coin.nowPrice * coin.now_pcs ).toFixed(4)}</b>
                    {" "}   $
                  </span>
                </li>
              ))}

            {/* MAIN COINS LIST (BUY MODE) */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "1800px",
                marginTop: "10px",
              }}
            >
              <ul style={{ width: "100%", maxWidth: "1800px", padding: 0 }}>
                {dataCoins
                  .filter((coin) => !coin.sell_mode)
                  .map((coin, index) => (
                    <li
                      key={index}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "10px",
                        marginBottom: "10px",
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                        backgroundColor: "#fcc2e3",
                      }}
                    >
                      <span style={{ fontWeight: "bold", color: "#43f" }}>
                        {coin.nameCoin.toUpperCase()}
                      </span>

                      <span>
                        Now Price: <b>{coin.nowPrice.toFixed(4)}</b> $
                      </span>

                      <span>
                        Now pcs: <b>{coin.now_pcs.toFixed(4)}</b>
                      </span>

                      <span>
                        First Price: <b>{coin.firstPrice.toFixed(4)}</b>
                      </span>

                      <span>
                        First pcs: <b>{coin.first_pcs.toFixed(4)}</b>
                      </span>

                      <span>
                        Buy/Sell Price: <b>{coin.buy_sell_price.toFixed(4)}</b>
                      </span>

                      <span>
                        nowPrice / (Buy/Sell):{" "}
                        <b>
                          {(coin.nowPrice / coin.buy_sell_price).toFixed(4)}
                        </b>
                      </span>

                      <span>
                        threshold_buy:
                        <button
                          style={{ marginLeft: "5px" }}
                          onClick={() =>
                            updateThreshold(
                              coin.nameCoin,
                              "buy",
                              coin.threshold_buy - 0.5
                            )
                          }
                        >
                          -
                        </button>
                        <b style={{ margin: "0 6px" }}>
                          {coin.threshold_buy.toFixed(2)}
                        </b>
                        <button
                          onClick={() =>
                            updateThreshold(
                              coin.nameCoin,
                              "buy",
                              coin.threshold_buy + 0.5
                            )
                          }
                        >
                          +
                        </button>
                      </span>

                      <span>
                        threshold_sell:
                        <button
                          style={{ marginLeft: "5px" }}
                          onClick={() =>
                            updateThreshold(
                              coin.nameCoin,
                              "sell",
                              coin.threshold_sell - 0.5
                            )
                          }
                        >
                          -
                        </button>
                        <b style={{ margin: "0 6px" }}>
                          {coin.threshold_sell.toFixed(2)}
                        </b>
                        <button
                          onClick={() =>
                            updateThreshold(
                              coin.nameCoin,
                              "sell",
                              coin.threshold_sell + 0.5
                            )
                          }
                        >
                          +
                        </button>
                      </span>

                      <span>
                        Profit:{" "}
                        <b>
                          {(
                            (coin.nowPrice - coin.buy_sell_price) *
                            coin.now_pcs
                          ).toFixed(4)}
                        </b>
                      </span>

                      <span>
                   
                   <b>{( coin.nowPrice * coin.now_pcs ).toFixed(4)}</b>
                   {" "}   $
                 </span>
                 
                    </li>
                  ))}
              </ul>
            </div>
            {/* SECONDARY COINS */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "1700px",
                marginTop: "10px",
              }}
            >
              <ul style={{ width: "100%", maxWidth: "1200px", padding: 0 }}>
                {dataCoinsSecondary.map((coin, index) => (
                  <li
                    key={index}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "10px",
                      marginBottom: "10px",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                      backgroundColor: "#fcc2e3",
                    }}
                  >
                    <span style={{ fontWeight: "bold", color: "#0004f5" }}>
                      {coin.nameCoin.toUpperCase()}
                    </span>

                    <span>
                      Now Price: <b>{coin.nowPrice}</b> $
                    </span>

                    <span>
                      Now pcs: <b>{coin.now_pcs}</b>
                    </span>

                    <span>
                      First Price: <b>{coin.firstPrice}</b>
                    </span>

                    <span>
                      First pcs: <b>{coin.first_pcs}</b>
                    </span>

                    <span>
                      Buy/Sell Price: <b>{coin.buy_sell_price}</b>
                    </span>
                  </li>
                ))}
              </ul>
            </div>
            <div
              style={{
                width: "1700px",
                height: "200px",
                overflowY: "scroll",
                background: "#111",
                color: "#0f0",
                padding: "10px",
                borderRadius: "8px",
                border: "1px solid #444",
                fontFamily: "monospace",
                fontSize: "12px",
              }}
            >
              {logs.map((line, i) => (
                <div key={i}>{line}</div>
              ))}
            </div>

            {/* ABCD Summary */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                paddingTop: "16px",
                // borderTop: "1px solid #374151",
                marginTop: "20px",
                marginLeft: "100px",
              }}
            >
              <div style={{ width: "80%" }}>
                <p style={{ fontSize: "25px", color: "#000" }}>
                  <span style={{ fontSize: "20px" }}>
                    {" "}
                    ( ارزش اولیه )
                    .............................................................
                    A ={" "}
                  </span>
                  <span style={{ fontSize: "24px" }}>∑</span>
                  <span style={{ fontSize: "18px" }}>
                    {" "}
                    ( price_first * pcs_first ) ={" "}
                  </span>
                  <span style={{ color: "#000", fontWeight: "bold" }}>
                    {abcd.A} $
                  </span>
                </p>

                <p style={{ fontSize: "25px", color: "#000" }}>
                  <span style={{ fontSize: "20px" }}>
                    {" "}
                    ( ارزش فعلی بعد از تریده )
                    ...............................................B ={" "}
                  </span>
                  <span style={{ fontSize: "24px" }}>∑</span>
                  <span style={{ fontSize: "18px" }}>
                    {" "}
                    ( price_now * pcs_now ) ={" "}
                  </span>
                  <span style={{ color: "#000", fontWeight: "bold" }}>
                    {abcd.B} $
                  </span>
                </p>

                <p style={{ fontSize: "25px", color: "#000" }}>
                  <span style={{ fontSize: "20px" }}>
                    {" "}
                    ( اگر هیچ تریدی نمی‌کردید )
                    ............................................. C ={" "}
                  </span>
                  <span style={{ fontSize: "24px" }}>∑</span>
                  <span style={{ fontSize: "18px" }}>
                    {" "}
                    ( price_now * pcs_first ) ={" "}
                  </span>
                  <span style={{ color: "#000", fontWeight: "bold" }}>
                    {abcd.C} $
                  </span>
                </p>

                <p style={{ fontSize: "25px", color: "#000" }}>
                  <span style={{ fontSize: "20px" }}>
                    {" "}
                    (اگر امروز می‌خواستید همین مقدار الان را با قیمت اولیه
                    بخرید)..... D =
                  </span>
                  <span style={{ fontSize: "24px" }}>∑</span>
                  <span style={{ fontSize: "18px" }}>
                    {" "}
                    ( price_first * pcs_now ) ={" "}
                  </span>
                  <span style={{ color: "#000", fontWeight: "bold" }}>
                    {abcd.D} $
                  </span>
                </p>
              </div>

              <div
                style={{
                  marginTop: "20px",
                  padding: "16px",
                  border: "1px solid #ccc",
                  borderRadius: "12px",
                  background: "#fff",
                  width: "600px",
                }}
              >
                <h2 style={{ marginBottom: "16px" }}>
                  Token Growth (now_pcs / first_pcs)
                </h2>

                <ul style={{ listStyle: "none", padding: 0 }}>
                  {dataCoins.map((coin, index) => {
                    const ratio = coin.now_pcs / coin.first_pcs;

                    return (
                      <li
                        key={index}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "8px",
                          marginBottom: "6px",
                          borderBottom: "1px solid #eee",
                          fontSize: "18px",
                        }}
                      >
                        <span style={{ fontWeight: "bold" }}>
                          {coin.nameCoin.toUpperCase()}
                        </span>

                        <span
                          style={{
                            color:
                              ratio > 1 ? "green" : ratio < 1 ? "red" : "#333",
                            fontWeight: "bold",
                          }}
                        >
                          {ratio.toFixed(4)}
                        </span>
                      </li>
                    );
                  })}
                  <p
                    style={{
                      fontSize: "22px",
                      color: tgi.percent >= 0 ? "green" : "red",
                    }}
                  >
                    Token Growth Index: <b>{tgi.percent}%</b>
                  </p>
                </ul>

                {/* TOTAL RATIO */}
                <div
                  style={{
                    marginTop: "16px",
                    paddingTop: "10px",
                    borderTop: "2px solid #333",
                    fontSize: "20px",
                    fontWeight: "bold",
                  }}
                >
                  Total Ratio:{" "}
                  {dataCoins
                    .reduce(
                      (sum, coin) => sum + coin.now_pcs / coin.first_pcs,
                      0
                    )
                    .toFixed(2)}
                </div>
              </div>
            </div>
          </ul>
        </div>
        <p>.</p>
      </div>
    </div>
  );
}

export default App;
